const menu = [
  {
    id: 1,
    cat: "basic",
    ispopular: true,
    food: "PiroAalu with chiura",
    img: "../../assets/images/tiffins_menus/PiroAloo.jpg",
    description: "PiroAalu with chiura",
    price: 120,
  },
  {
    id: 2,
    cat: "basic",
    ispopular: true,
    food: "Chatpate",
    img: "../../assets/images/tiffins_menus/Chatpat.jpg",
    description: "Chatpate",
    price: 60,
  },
  {
    id: 3,
    cat: "basic",
    ispopular: false,
    food: "Panipuri",
    img: "../../assets/images/tiffins_menus/panipuri.jpg",
    description: "Panipuri",
    price: 60,
  },
  {
    id: 4,
    cat: "basic",
    ispopular: true,
    food: "French fry",
    img: "../../assets/images/tiffins_menus/frenchfry.jpg",
    description: "French fry",
    price: 120,
  },
  {
    id: 5,
    cat: "basic",
    ispopular: false,
    food: "Chowmein",
    img: "../../assets/images/tiffins_menus/chowmein.jpg",
    description: "Chowmein",
    price: 100,
  },
  {
    id: 6,
    cat: "basic",
    ispopular: false,
    food: "Fry rice",
    img: "../../assets/images/tiffins_menus/fryrice.jpg",
    description: "Fry rice",
    price: 120,
  },
  {
    id: 7,
    cat: "basic",
    ispopular: false,
    food: "Manchurian",
    img: "../../assets/images/tiffins_menus/manchurain.jpg",
    description: "Manchurian",
    price: 120,
  },
  {
    id: 8,
    cat: "special",
    ispopular: true,
    food: "Manchurian with chowmein",
    img: "../../assets/images/tiffins_menus/1.chowmeinwithrice.png",
    description: "Manchurian with chowmein",
    price: 120,
  },
  {
    id: 9,
    cat: "special",
    ispopular: false,
    img: "../../assets/images/tiffins_menus/RotiVegCurry.jpg",
    food: "Roti with Veg Curry",
    price: 120,
  },
  {
    id: 10,
    cat: "special",
    ispopular: true,
    food: "Manchurian with Roti",
    img: "../../assets/images/tiffins_menus/5.Roti with manchurian.png",
    description: "Manchurian with Roti",
    price: 120,
  },
  {
    id: 11,
    cat: "special",
    ispopular: true,
    food: "Chowmein with Fry rice",
    img: "../../assets/images/tiffins_menus/4.Chowmien with fryrice.png",
    description: "Chowmein with Fry rice",
    price: 120,
  },
  {
    id: 12,
    cat: "special",
    ispopular: true,
    food: "Plain Rice with Veg Curry",
    img: "../../assets/images/tiffins_menus/2.Plainrice with veg curry.png",
    description: "Plain Rice with Veg Curry",
    price: 120,
  },
  {
    id: 14,
    cat: "special",
    ispopular: true,
    food: "Fry Rice with Veg Curry",
    img: "../../assets/images/tiffins_menus/6.Fryrice with veg curry.png",
    price: 120,
  },
  {
    id: 15,
    cat: "special",
    ispopular: false,
    food: "Manchurian with Fry rice",
    img: "../../assets/images/tiffins_menus/3.Manchurian with fryrice..png",
    description: "Manchurian with Fry rice",
    price: 120,
  },
];

export { menu };
